// extracted by mini-css-extract-plugin
module.exports = {"SearchNotificationContainer":"SearchNotification_SearchNotificationContainer__Ot3bz"};